// removed by extract-text-webpack-plugin
module.exports = {"header_video_container":"_37o8OuUMcapAOWE_tXfRV-","imgCover":"_1C6dnp6fu23fPApXQs9Ile"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Video/Video.scss
// module id = 1789
// module chunks = 0